import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Box, Grid2, Stack, Typography, useTheme } from "@mui/material";
import { OutlineEdit, TrashCan } from "../../../../Icon";
import { EGSpeedDial } from "../../../../MainComponents/Button/SpeedDial/SpeedDial";
import { InvestigationBlockInfo, InvestigationItemContainer } from "../components";
import { getSelectionChain } from "../../../../MainComponents/Catalogues/utils/GetSelectionChain";
// import { useBusinessUnit } from "./hooks/useBusinessUnit";

export const SingleScenario = ({
  idx,
  main,
  scenario,
  scenarios,
  handleSaveScenarios,
  setSelectedScenario,
  setIsEditing,
  justView,
  openConfirmDeleteModal,
  closeModalConfirm,
}) => {

  const theme = useTheme();
  const [t] = useTranslation("investigation");

  const [centerSelections, setCenterSelections] = useState([]);
  const requestIdRef = useRef(0);
  
  const { 
    details = "", 
    location = "", 
    inside = false, 
    center = "",
    area = "",
  } = scenario;

  useEffect(() => {
    if (scenario.center) {
      const currentRequestId = ++requestIdRef.current;
      getSelectionChain({
        catalogue: "business_units",
        isOwn: true,
        value: center,
      }).then((selections) => {
        if (currentRequestId === requestIdRef.current) {
          setCenterSelections(selections);
        }
      }).catch((error) => {
        if (currentRequestId === requestIdRef.current) {
          console.error('Error fetching center selections:', error);
        }
      });
    } else {
      setCenterSelections([]);
    }
  }, [scenario.center]);

  const handleEdit = () => {
    setSelectedScenario(idx);
    setIsEditing(true);
  }

  const openModalReopenInvestigation = () => {
    openConfirmDeleteModal({ onConfirm: () => handleRemoveScenario(idx) });
  }

  const handleRemoveScenario = async (idx) => {
    const newScenarios = _.cloneDeep(scenarios);
    newScenarios.splice(idx, 1);
    await handleSaveScenarios(newScenarios);
    closeModalConfirm();
  };

  const actions = [
    {
      color: "success",
      name: t("speeddial.edit"),
      icon: <OutlineEdit color={theme.palette.primary.main} />,
      onClick: handleEdit,
    },
    {
      color: "error",
      name: t("speeddial.delete"),
      icon: <TrashCan color={theme.palette.error.main} />,
      onClick: openModalReopenInvestigation,
    },
  ];

  return (
    <InvestigationItemContainer 
      color={main ? theme.palette.primary.main : "#25A568" }
      sx={{ padding: 2 }} 
    >

      <Stack direction="row" justifyContent="space-between">

        <Typography fontSize={16} fontWeight={600} >
          {
            main ? t("locations.location_marked_by_the_client") :
            inside 
            ? t("locations.location_inside_the_work_center")
            : t("locations.location_outside_the_work_center")
          }
        </Typography>

        {
          !justView &&
          <Box style={{ minWidth: "35px", position: "relative" }}>
            <EGSpeedDial
              direction="left"
              actions={actions}
              sx={{
                position: "absolute",
                top: "50%",
                right: 0,
                transform: "translateY(calc(-50% - 5px))",
                scale: 0.8
              }}
            />
          </Box>
        }

      </Stack>

      <hr />

      <Grid2 container spacing={2}>
        {
          !inside ? (
            <InvestigationBlockInfo 
              label={t("locations.location")}
              text={location}
            />

          ) : (
            centerSelections.map((item,idx)=>(
              <InvestigationBlockInfo 
                key={idx}
                label={centerSelections[idx-1] || t("locations.work_center")}
                text={item}
              />
            ))
          )
        }
        {
          details &&
          <InvestigationBlockInfo 
            label={t("locations.details")}
            text={details}
            size={12}
          />
        }
        {
          area &&
          <InvestigationBlockInfo 
            label={t("locations.area")}
            text={area}
            size={12}
          />
        }
      </Grid2>


    </InvestigationItemContainer>
  )
};

export const SingleScenarioReport = ({ scenario }) => {
  
  const { lang } = useSelector((state) => state.lang);
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const getLabel = (label, locales) => locales ? locales[lang] ?? label : label;

  return (
    <InvestigationItemContainer 
      color={theme.palette.primary.main}
      sx={{ padding: 2 }} 
    >

      <Typography fontSize={16} fontWeight={600} >
        {t("locations.location_marked_by_the_client_report")}
      </Typography>

      <hr />

      <Grid2 container spacing={2}>

        {
          scenario.map((item,idx)=>(
            <InvestigationBlockInfo 
              key={idx}
              label={getLabel(item.label, item.locales)}
              text={getLabel(typeof item.text_value === "string" ? item.text_value : "", item.locales_value)}
            />
          ))
        }

      </Grid2>

    </InvestigationItemContainer>
  )
};